<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Suggestions</span>
    <b-tabs card no-fade>
      <b-tab title="Unread" active>
        <unread/>
      </b-tab>
      <b-tab title="Read">
        <read/>
      </b-tab>
    </b-tabs>
  </page>
</template>

<script>
import page from '../../../templates/page'
import read from './read'
import sidebar from '../../../sidebar'
import unread from './unread'

export default {
  components: {
    unread,
    read,
    sidebar,
    page
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/suggestions/index.vue